import { useToast } from '@chakra-ui/react';
import { AxiosResponse } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { init } from '~/services/Init';

export function useInit(): UseMutationResult<
  AxiosResponse<any>,
  unknown,
  unknown,
  unknown
> {
  const toast = useToast();

  return useMutation(async () => init(), {
    onSuccess: () => {
      toast({
        title: 'Init executado',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top-right',
      });
    },
    onError: () => {
      toast({
        title: 'Erro',
        description: 'Erro ao executar init, tente novamente',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top-right',
      });
    },
  });
}
